import Vue from "vue";

export class Fibra {
    static create() {
        return {
            porta_pon: {
                _id: null,
                nome: null
            },
            numero: null,
            nome: null
        };
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static byID(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("fibra/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static byPortaPon(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("fibra/by-porta-pon/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static excluir(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .delete("fibra/" + id)
                .then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static all() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("fibras")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param data
     * @return {Promise}
     */
    static save(data) {
        return new Promise((resolve, reject) => {
            let promisse = null;

            if (data._id) {
                promisse = Vue.http.put("fibra/" + data._id, data);
            } else {
                promisse = Vue.http.post("fibra/0", data);
            }

            promisse.then(() => resolve(), err => reject(err));
        });
    }
}
